import { render, staticRenderFns } from "./listInfo.vue?vue&type=template&id=22a1bb58"
import script from "./listInfo.vue?vue&type=script&lang=js"
export * from "./listInfo.vue?vue&type=script&lang=js"
import style0 from "./listInfo.vue?vue&type=style&index=0&id=22a1bb58&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports